export default "__VITE_ASSET__BHkN5jH5__"